$(function(){
  //Image Viewer
  $(document).on('touchend click','.thumb',function(){
    let _cssUrl = "url('"+ $(this).data('stdsrc') +"')";
    let _maxsrc = $(this).data('maxsrc') || $(this).data('stdsrc'); //if no maxsrc, set to std

    //handle product images
    $('#ckboxPoster').css({'background-image': _cssUrl}).data('maxsrc',_maxsrc);
  });
  $(document).on('mouseenter','#ckboxPoster',function(){
    $(this).append('<span class="catalogItemMag glyphicon glyphicon-search"></span>');
  });
  $(document).on('mouseleave','#ckboxPoster',function(){
    $(this).find('.catalogItemMag').remove();
  });
  $(document).on('click touchend','#ckboxPoster',function(ev){
    let selectedItem =  $(ev.target).hasClass('catalogItemMag')  ? $(ev.target).parent() : $(ev.target);
    ck.showLightbox(selectedItem);
  });
  $(document).on('click touchend','.lbClose,.lbLink,.lbBackdrop',function(){
    setTimeout(function () {
      $('.lbWrapper').remove();
    },1); //prevent clicks on targets under lightbox and allow new window to instantiate on iPhones
  });

  ck.showLightbox = function(_this){
    let _imageUrl = $(_this).data('maxsrc') || _this.image_url;
    let _lbEl = '<div class="lbWrapper"><div class="lbBackdrop"></div>';
    if(_this.link_url && _this.link_url.length > 0){
      _lbEl += '<a class="lbLink" href="'+ _this.link_url +'" target="_blank"><div id="lbImage" class="lbImage"></div></a>';
    } else {
      _lbEl += '<div id="lbImage" class="lbImage"></div>';
    }
    _lbEl += '<div class="lbClose glyphicon glyphicon-remove"></div></div>';

    let _loadingImage = new Image();
    _loadingImage.onload = function(){
      let _cssUrl = "url('"+ this.src +"')";
      let _cssHeight = this.height + 'px';
      let _cssWidth = this.width + 'px';
      $('#lbImage').css({'background-image':_cssUrl,'height':_cssHeight,'width':_cssWidth});
    };
    _loadingImage.src = _imageUrl;
    $('body').append(_lbEl);
  };

  //firing event from legacy ui for vue component to capture and trigger rotate
  $(document).on('click','.flipCardLink',function(ev){
    $(document).trigger('swapFlipImages.ck');
  });

});